import React from "react";
import GoogleReviewSummary from "./GoogleStars";
import { CalendarIcon } from "@radix-ui/react-icons";
import { cn } from "@/lib/utils";
import ButtonPrime from "@/components/navigation/ButtonPrime";
import BeratungsterminModal from "@/components/form/BeratungsterminModal";

export default function DetailsLp({ className }) {
  return (
    <div
      className={cn(
        " max-w-7xl px-2 mx-auto pt-14 md:pt-20 pb-14 md:pb-20 flex flex-col-reverse md:grid grid-cols-5 gap-5",
        className
      )}
    >
      <div className="md:flex justify-between col-span-3">
        <div className=" relative before:absolute before:-left-1 md:before:-left-5 before:h-[calc(100%-30px)] before:w-1 md:before:w-1">
          <h2 className="font-bold text-center md:text-left md:px-0 pb-5 pt-7 md:pt-0 text-2xl md:text-4xl md:pb-10 text-dark-100">
            Vertrauen über Generationen
          </h2>
          <p className="pb-5 md:text-left text-dark-200  mx-auto text-center max-w-[35rem]">
          Als Ihr Immobilienmakler in Eschweiler, Stolberg, Aachen und der Region begleiten wir Menschen seit 1978 durch Lebenswendungen: Vom ersten Eigenheim über kluge Investitionen bis zur Weitergabe von Familiengut. Generationen vertrauten uns an, was ihnen wichtig ist – weil wir Immobilien nicht als Ware, sondern als Stück gelebter Geschichte behandeln.
          </p>
          <GoogleReviewSummary className="hidden md:flex" />
          <div className="md:w-1/2">
            <BeratungsterminModal
              trigger={
                <ButtonPrime
                  className="w-full md:w-[25rem] mt-5"
                  icon={<CalendarIcon className="size-7 mr-2 inline" />}
                  variant="outline"
                >
 Kostenlos Beratungstermin buchen
                </ButtonPrime>
              }
              description="Wir freuen uns auf Ihre Anfrage!"
            >
            </BeratungsterminModal>
          </div>
        </div>
      </div>
      <div className="col-span-2 mx-auto">
        <img loading="lazy" className=" rounded-lg" src="/Fotos/verkaufen-hero-jakobs.jpg" alt="Bild von Helga und Leon Jakobs am Büroeingang auf der Uferstr 40" />
      </div>
    </div>
  );
}
